import { Controller } from '@hotwired/stimulus';
import tippy, { hideAll } from 'tippy.js';
import NwMap from '../libs/nw_map';

export default class extends Controller {
  static targets = ['image', 'marker'];

  connect() {
    hideAll();

    // Draw markers after one second so that map image is hopefully already loaded
    setTimeout(() => {
      this.drawMarkers();

      tippy('.labeled-marker', {
        content(reference) {
          const id = reference.getAttribute('data-label-template') as string;
          const template = document.getElementById(id) as HTMLElement;
          return template.innerHTML;
        },
        allowHTML: true,
        interactive: true,
        animation: 'scale',
        appendTo: document.body,
      });
    }, 1000);

    // Ensure that markers are redrawn whenever window size is changed
    window.onresize = this.drawMarkers;
  }

  drawMarkers() {
    this.markerTargets.forEach((marker: HTMLElement) => {
      NwMap.drawMarker(this.imageTarget, marker);
    });
  }

  declare imageTarget: HTMLImageElement;

  declare markerTargets: HTMLElement[];
}
